<template>
    <div>
        <section class="base-header-sec base-header-laen  laen">
            <div class="base-header__top-line laen"></div>
            <div class="container-fluid">

                <div class="   base-header__container ">
                    <div class="  d-flex justify-content-center align-items-center">
                        <h1 class="base-header__title text-center py-2">
                            <!--                            <span class="base-header__icon icon-inbox mr-3"></span>-->
                            {{ pageData.title }}
                        </h1>
                    </div>
                </div>
            </div>
        </section>


        <div class="container-fluid base-container">
            <div class="base-box base-box__table-sec">
                <iframe :src="baseApiUrl + pageData.url" :width="fontSize" :height="(Number.parseInt(fontSize) / 100)* 600 + 'px'" frameborder="0" id="iframeContent"></iframe>
            </div>
        </div>
    </div>
</template>

<script>

import { mapState } from 'vuex';

export default {
    name: "StaticPage",
    data() {
        return {
            loaded: false,

            baseApiUrl: window.env.VUE_APP_API_FP_DEV,
             
            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },
        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    computed: {
        ...mapState(['fontSize']),
        pageData() {
            let pageData = {
                title: null,
                url: null,
            };

            switch (this.$route.params.page) {
                case 'termsOfService':
                    // code block
                    pageData.url = 'prins/GetStaticPageByCode/TermsOfService';
                    pageData.title = 'Услови коришћења';
                    break;
                case 'impressum':
                    // code block
                    pageData.url = 'prins/GetStaticPageByCode/F01';
                    pageData.title = 'Импресум ';
                    break;
                case 'contact':
                    // code block
                    pageData.url = 'prins/GetStaticPageByCode/F02';
                    pageData.title = 'Контакт';
                    break;
                default:
                    pageData.url = null;
                    pageData.title = null;
                // code block
            }
            return pageData;
        }
    },
    mounted() {
    },
    beforeCreate: function () {
        document.body.className = 'color_standard';
    }

}
</script>

<style scoped></style>
